import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import dayjs from 'dayjs';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

import DialogContentText from '@mui/material/DialogContentText';
const iconContainerStyle = { position: 'relative', right: '5px', border:'none', boxShadow:'none', display: 'flex', justifyContent: 'center', background: '#1D3440', color: '#fff', width: '5px', height: '5px', borderRadius: '10px', padding: '10px'}
const headerStyle = { display: 'flex', gap:'10px', color: '#1D3440', fontSize: '16px', fontWeight: 'bold'}
const outcomeBadge = {display: 'flex', justifyContent: 'center', width:'fit-content', backgroundColor: '#D3D3D3',  color: '#1D3440', fontWeight: 'normal', padding:'5px', borderRadius: '10px'}
const contentStyle = { display: 'flex', flexDirection: 'column', gap:'5px', padding: '5px', position: 'relative', left: '-10px', top: '-30px', boxShadow: 'rgba(0, 0, 0, 0.05) 0px 15px 10px 0px' }
const summaryText = {color: '#666666', fontSize: '0.85rem'}
const mainSummaryText = {color: '#666666', fontSize: '0.85rem'}
const authorText = {color: '#aaaaaa', fontStyle:'italic', fontSize: '13px'}

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip
      {...props}
      classes={{ popper: className }}
        slotProps={{
            popper: {
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [120, 20],
                  },
                },
              ],
            },
          }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: '#666666',
    boxShadow: theme.shadows[1],
    fontSize: 14,
    paddingTop: '20px'
  },
}));


const Timeline = ({summaries, mainSummary})=>{
    const approvedSummaries = summaries.filter((summary)=>{
        return summary.approved;
    })
    return(
        <div style={{height: 'fit-content', width: '100%'}}>
            <div style={{display: 'flex', flexDirection: 'column', gap: '5px', justifyContent: 'center', paddingBottom: '30px'}}>
                <div style={{display: 'flex', gap: '5px', alignItems: 'center', paddingBottom: '5px'}}>
                    <DialogContentText>
                       Overall Summary
                    </DialogContentText>
                    <AutoAwesomeIcon/>
                </div>

                {
                    mainSummary?
                        <div style={mainSummaryText}>{mainSummary?.overwritten_summary?mainSummary.overwritten_summary:mainSummary.original_summary}</div>
                        :
                        <div style={mainSummaryText}>Not available</div>
                }
            </div>
            {
                approvedSummaries.length>0?
                    <VerticalTimeline lineColor={'rgba(0, 0, 0, 0.10)'} layout={'1-column-left'}>
            {
                approvedSummaries.map((summary, index)=>{
                    return(
                        <VerticalTimelineElement
                            key={index}
                            className="vertical-timeline-element--work"
                            style={{margin: '5px', padding:'5px'}}
                            iconStyle={iconContainerStyle}
                            contentStyle={contentStyle}
                            position={'right'}
                          >
                           <div style={headerStyle}>
                               {dayjs(summary.created_at).format('DD MMMM YYYY')}
                            </div>
                            <div style={{...outcomeBadge}}>
                                {summary.metadata.recommendation??"Recommendation not available"}
                            </div>

                            <div style={summaryText}>{summary?.overwritten_summary?summary.overwritten_summary:summary.original_summary}</div>
                            <div style={authorText}>{summary?.approved_by}</div>

                          </VerticalTimelineElement>
                    )
                })
            }
            </VerticalTimeline>
                    :
                    null

            }


            </div>
    )

}

export default Timeline;
